@if (isHeaderTextShown) {
    <h5 class="centered-heading">{{headerText}}</h5>
}

@if (isQrInvitationTextShown) {
    <div class="row alert ">
    <h5 class="text-center">{{qrInvitationText}}</h5>
    <!-- <h5 class="text-center">{{'qrInvitationText' | translate}}</h5> -->
    </div>
    <div class="row image-text">
        <div style="text-align: center;">
            <img id="qrCode" src="{{qrCodeUrl}}" alt="" width="250" height="250" />
        </div>
    </div>
}

@if (isSmsInvitationTextShown) {
    <div class="row alert ">
    <h5 class="text-center">{{smsInvitationText}}</h5>
    </div>
    <div class="row image-text">
        <div class="image-text__image" style="text-align: center;">
            <img class="img-fluid mx-auto d-block" [src]="smsMeImage" >
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button type="button" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onOpenSMSModal()">Send SMS</button>
        </div>
    </div>
}

@if (isEmailInvitationTextShown) {
    <div class="row alert ">
    <h5 class="text-center">{{emailInvitationText}}</h5>
    </div>
    <div class="row image-text">
        <div class="image-text__image" style="text-align: center;">
            <img class="img-fluid mx-auto d-block" [src]="emailMeImage" >
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button type="button" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onOpenEmailModal()">Send Email</button>
        </div>
    </div>
}

<div class="row">
    <div class="col-12 text-center">
        <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
    </div>
</div>



<div class="modal" [style]="{'display':isPhoneFormOpen() || isEmailFormOpen() ? 'block' : 'none'}">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">{{modalTitle}}</h5>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>

            <div class="modal-body">

                <form [formGroup]="phoneForm" (change)="formChanged()" [style]="{'display':isPhoneFormOpen() ? 'block' : 'none'}">

                    <div class="row">
                        <div class="col-sm-6 col-12">
                            <div class="form-group">
                                <label>PHONE NUMBER</label>
                                <div class="input-group">
                                    <input type="text" formControlName="phoneNumber" appPhoneMask class="form-control" id="phoneNumber" placeholder="(ddd) ddd-dddd" />
                                    <div class="input-group-append"></div>
                                </div>
                                @if (!phoneForm.get('phoneNumber')?.valid && phoneForm.get('phoneNumber')?.dirty) {
                                    <div class="alert alert-danger">
                                        Incorrect phone number
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </form>

                <form [formGroup]="emailForm" (change)="formChanged()" [style]="{'display':isEmailFormOpen() ? 'block' : 'none'}">

                    <div class="row">
                        <div class="col-sm-6 col-12">
                            <div class="form-group">
                                <label>EMAIL ADDRESS</label>
                                <div class="input-group">
                                    <input type="text" formControlName="emailAddress" appPhoneMask class="form-control" id="emailAddress" placeholder="Email Address" />
                                    <div class="input-group-append"></div>
                                </div>
                                @if (!emailForm.get('emailAddress')?.valid && emailForm.get('emailAddress')?.dirty) {
                                    <div class="alert alert-danger">
                                        Incorrect email address
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </form>


            </div>

            <div class="modal-footer">

                <div class="row">
                    <div class="col-12 text-center">
                        @if(isEmailFormOpen()) {
                            <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onSendEmail()" [disabled]="!emailForm.valid">Send Email</button>
                        }
                        @if(isPhoneFormOpen()) {
                            <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onSendSMS()" [disabled]="!phoneForm.valid">Send SMS</button>
                        }
                        <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="closeModal()" label="Cancel">Cancel</button>
                    </div>
                </div>

                <div class="row alert ">
                    @if (isSuccessMessageShown) {
                        <div class="alert alert-success" role="alert">{{successMessage}}</div>
                    }
                    @if (isErrorMessageShown) {
                        <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
                    }    
                </div>                  

            </div>

        </div>
    </div>
  </div>  
